import React from "react";
import { Route, withRouter } from "react-router-dom";
import { inject } from "mobx-react";
import { compose } from "recompose";
import { graphql } from "@apollo/client/react/hoc";
import { OPERATOR_HEADER_QUERY, TAGS_ONE_QUERY } from "Services/queries";
import withDefaultParams from "Services/withDefaultParams";
import WithSeoText from "Layouts/WithSeoText";
import OperatorHeaderWrapperContainer from "Containers/OperatorHeaderWrapperContainer";
import { Redirect404 } from "ComponentsUI/Redirects";

const Wrapper = (props) => {
	if (
		props.operatorQuery.loading ||
		(!!props.match.params?.tagCode && props?.tagsOneQuery?.loading)
	) {
		return null;
	}

	if (
		!props.operatorQuery.provider ||
		(!!props.match.params?.tagCode && !props?.tagsOneQuery?.tagsOne)
	) {
		return <Redirect404 message404={"Отсутствует оператор или не правильно выбран его тег"} />;
	}

	let {
		ApplicationModel: { routesModel, text },
	} = props;

	let tagsOne = props?.tagsOneQuery?.tagsOne || null;
	routesModel.setTag(tagsOne);
	routesModel.setProvider(props.operatorQuery.provider);

	const rest = props.rest;
	const matchProps = props.matchProps;
	const MainComponent = props.mainComponent;
	let operatorForCard = props?.operatorQuery?.provider;
	let hideText;

	if (!operatorForCard?.info.cnt_action_tariffs && rest?.seoPath === "OperatoryActions") {
		hideText = true;
	}

	return (
		<>
			<OperatorHeaderWrapperContainer
				seoData={props.seoData}
				notH1={rest.notH1}
				defaultHeader={rest.defaultHeader}
				data={props.operatorQuery}
				operatorForCard={operatorForCard}
			/>
			<WithSeoText seoData={props.seoData} text={text} hideText={hideText}>
				<MainComponent {...matchProps} seoData={props.seoData} operatorForCard={operatorForCard} />
			</WithSeoText>
		</>
	);
};

const WrapperWithData = withRouter(
	withDefaultParams(
		compose(
			graphql(TAGS_ONE_QUERY, {
				skip: (props) => {
					return !props.match.params?.tagCode;
				},
				options: (props) => {
					let filter = [`translit=${props.match.params.tagCode}`];
					switch (props?.rest?.seoPath) {
						case "OperatoryTariffs":
							filter.push("type=mobile");
							break;
						case "OperatoryBeautifulNumbers":
							filter.push("type=beauty");
							break;
					}
					return {
						variables: {
							filter: filter.join("&"),
						},
					};
				},
				props: ({ ownProps, data }) => {
					if (data) {
						return {
							...ownProps,
							tagsOneQuery: data,
						};
					}
				},
			}),
			graphql(OPERATOR_HEADER_QUERY, {
				options: (props) => {
					let regionUrl = props?.match?.params?.regionUrl || "";
					let filter = `region.url=${regionUrl}&url_name=${props.match.params.operator}&mobile_operator=1`;

					return {
						variables: {
							filter: filter,
						},
					};
				},
				props: ({ ownProps, data }) => {
					if (data) {
						return {
							...ownProps,
							operatorQuery: data,
						};
					}
				},
			})
		)(Wrapper)
	)
);

const OperatorsLayout = ({ component: Component, seoData, ApplicationModel, ...rest }) => {
	return (
		<Route
			{...rest}
			render={() => {
				return (
					<WrapperWithData
						currentRegion={ApplicationModel.currentRegion}
						seoData={seoData}
						rest={rest}
						mainComponent={Component}
						ApplicationModel={ApplicationModel}
					/>
				);
			}}
		/>
	);
};

export default inject("ApplicationModel")(OperatorsLayout);
